import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';

import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { AccountService } from '../../../core/service/app/account.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent extends FormBaseComponent<any> implements OnInit {

  showMessage = false;
  @Output()
  onSuccess = new EventEmitter<any>();

  formRecover: FormGroup;
  formRecoverSet: FormGroup;

  errorRecover = '';
  errorRecoverSet = '';

  constructor(private accountService: AccountService) {
    super();
  }

  viewUi = 'login'

  ngOnInit() {
    this.init();

    this.formRecover = new FormGroup({
      'email': new FormControl('', [Validators.required, Validators.email])
    })

    this.formRecoverSet = new FormGroup({
      'code': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required]),
      'passwordRepeat': new FormControl('', [Validators.required]),
    })
  }
  template() {
    this.form.addControl('email', new FormControl('comercio1@gmail.com', [Validators.required, Validators.email]));
    this.form.addControl('password', new FormControl('123', Validators.required));
  }

  changeView(value) {
    this.viewUi = value;
  }

  send() {
    if (this.form.valid) {
      this.showMessage = false;
      this.accountService.login(this.data())
        .then(result => {
          if (result == undefined) {
            this.clear();
            this.onSuccess.emit();
          } else {
            this.showMessage = true;
          }
        })
    }
  }

  recover() {
    this.accountService.sendCode(this.formRecover.get('email').value)
      .then(result => {
        if (result) {
          this.viewUi = 'recoverSet'
        } else {
          this.errorRecover = 'El correo no se registro.'
        }
      })
  }

  recoverSet() {
    let result = {
      ...this.formRecoverSet.value,
      email: this.formRecover.get('email').value
    }
    this.accountService.recover(result)
      .then(result => {
        if (result) {
          this.viewUi = 'login'
        } else {
          this.errorRecoverSet = 'Codigo invalido o las contraseñas no son iguales.'
        }
      })

  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/login-form/login-form.component.ts